import { render, staticRenderFns } from "./SliderRow.vue?vue&type=template&id=800243fe&"
import script from "./SliderRow.vue?vue&type=script&lang=js&"
export * from "./SliderRow.vue?vue&type=script&lang=js&"
import style0 from "./SliderRow.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseSwiper: require('/opt/build/repo/storefront/components/atoms/Layout/BaseSwiper.vue').default})
